import React, { useEffect, useMemo, useState } from 'react';
import { themeStore, userStore } from '../../store';
import { finishedTheme } from '../../utils/common';
import styles from './assets/index.module.scss';
import useService from './service';
import { useNavigate } from 'react-router-dom';
import Loading from '../../utils/Loading';
import Emptyer from '../../utils/Emptyer';
import { Popup, Tag, Toast } from 'antd-mobile';
import { useUpdateEffect } from 'ahooks';
import useAppService from '../../useAppService';

export default function DDS_lanhupage_0() {

  const { loading, dataStudy, runStudy, loadingAllDept, allDept, runAllDept } = useService()
  const { runUpdateDept, deptName, runTheme, runUpdDeptLoading } = useAppService(false)
  const { company, dept, isCompanyFinished } = themeStore;
  const { waitForExamKnowledgeId, lineId } = userStore;
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // console.log('lineId',lineId)
    runStudy();
    runAllDept();
  }, [lineId])

  useUpdateEffect(() => {
    runTheme()
  }, [deptName])

  const myThemeJsx = useMemo(() => (
    <span className={`${styles.info2}`}>
      {finishedTheme(isCompanyFinished ? dept : company)}/{isCompanyFinished ? dept.length : company.length}门
    </span>
  ), [company, dept, isCompanyFinished])

  const myStudyCount = useMemo(() => dataStudy.filter(a => a.record !== '100').length, [dataStudy])

  const historyStudyJsx = useMemo(() => {
    if (loading) {
      return <Loading />
    }
    if (dataStudy.length === 0) {
      return <Emptyer desc='暂无历史学习记录' />
    }
    return dataStudy.map((item, i) => (
      <div key={item.knowledgeId + i}>
        <div className={`${styles.outer5} flex-row justify-between`}>
          <div className={`${styles.block4} flex-col`}>
            <img
              className={`${styles.img1}`}
              src={
                require('./assets/img/SketchPngac24b57d4fdf048ee216b4d1e57adb8884388eb936dec316267c11d60bcdda8e.png')
              }
            />
          </div>
          <div className={`${styles.TextGroup6} flex-col`}>
            <div className={`${styles.main3} flex-col`}>
              <span className={`${styles.txt2}`}>{item.knowledgeName}</span>
              <span className={`${styles.word8}`}><Tag color='success' style={{ marginLeft: 0 }}>已学完</Tag></span>
              <span className={`${styles.txt3}`}>{item.updatedTime.substring(0, 10)}</span>
            </div>
          </div>
        </div>
        {i < dataStudy.length - 1 && (
          <img
            className={`${styles.pic2}`}
            src={
              require('./assets/img/SketchPng2a2b39252316f295592dca01fb91c06dee0a6cf9636c62befc29878553cfb646.png')
            }
          />
        )}
      </div>
    ))
  }, [dataStudy])

  const verify = (deptId, deptName) => {
    runUpdateDept({
      deptId, deptName
    })

  }

  useEffect(() => {
    setVisible(false)
  }, [!runUpdDeptLoading])

  const allDeptJsx = useMemo(() => {
    if (loadingAllDept) {
      return <Loading />
    }
    return allDept.map((d, i) => {
      const { deptName, deptId } = d;
      return <div key={i} className={`${styles.dept}`} onClick={() => verify(deptId, deptName)}>
        {deptName}
      </div>
    })
  }, [allDept, loadingAllDept])

  const chooseDept = () => {
    if (isCompanyFinished) {
      setVisible(true)
    } else {
      Toast.show({
        content: '请先学完公司级课程并通过考试'
      })
    }
  }

  const goToExam = () => {
    if (waitForExamKnowledgeId) {
      navigate(`/lanhu_7?exam=${waitForExamKnowledgeId}`)
    } else {
      Toast.show({
        content: '没有待考试记录'
      })
    }
  }

  const changeLine = () => {
    navigate('line')
  }

  return lineId ?
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.mod1} flex-col`}>
        <div className={`${styles.bd1} flex-col`}>
          <div className={`${styles.block1} flex-row`}>
            <div className={`${styles.word1}`}>
              <span className={`${styles.a}`}>培训考试</span>
              <span className={`${styles.b1}`} onClick={() => changeLine()}>切换条线</span>
            </div>
            <div className={`${styles.block111}`} onClick={chooseDept}>
              <span className={`${styles.SelectArea1}`}>{deptName}</span>
              <div className={`${styles.layer1} flex-col`} />
            </div>
          </div>
          <div className={`${styles.ImageText1} flex-col`}>
            <div className={`${styles.outer1} flex-row justify-between`}>
              <img
                className={`${styles.pic1}`}
                src={
                  require('./assets/img/SketchPng97bd6484c07dd9c82b8607c479db9689016b5695a7eb7b25b581c94a46bc88cc.png')
                }
              />
              <div className={`${styles.main1} flex-col justify-between`}>
                <div className={`${styles.TextGroup1} flex-col`}>
                  <div className={`${styles.layer2} flex-col justify-between`}>
                    <span className={`${styles.word2}`}>外协单位安全进场</span>
                    <span className={`${styles.word3}`}>培训考试</span>
                  </div>
                </div>
                <button
                  className={`${styles.Button1} flex-col`}
                  onClick={() => {
                    navigate('/lanhu_2')
                  }}
                >
                  <div className={`${styles.box1} flex-row`}>
                    <div className={`${styles.ImageText2} flex-col`}>
                      <div className={`${styles.box1} flex-row justify-between`}>
                        <div className={`${styles.TextGroup2} flex-col`}>
                          <span className={`${styles.info1}`}>开始学习</span>
                        </div>
                        <div className={`${styles.group1} flex-col`}>
                          <img
                            className={`${styles.label1}`}
                            src={
                              require('./assets/img/SketchPng74214a7f7e653ac1b738191bdeb3de97b46debedec2ba1c9f306178057a882f7.png')
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className={`${styles.block2} flex-row justify-between`}>
            <div className={`${styles.outer2} flex-col`}>
              <div className={`${styles.group2} flex-row justify-between`}>
                <div className={`${styles.box2} flex-col justify-between`}>
                  <span className={`${styles.word4}`}>{isCompanyFinished ? '部门级' : '公司级'}课程</span>
                  {myThemeJsx}
                </div>
                <div className={`${styles.ImageText3} flex-col`}>
                  <div className={`${styles.outer3} flex-col justify-between`}>
                    <div className={`${styles.box3} flex-col`} />
                    <div className={`${styles.TextGroup3} flex-col`}>
                      <span className={`${styles.word5}`}><span onClick={() => navigate('/lanhu_2')} href='./lanhu_2' className={styles.word5}>去学习〉〉</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.outer4} flex-col`}>
              <div className={`${styles.layer3} flex-row justify-between`}>
                <div className={`${styles.section1} flex-col justify-between`}>
                  <span className={`${styles.txt1}`}>尚未完成</span>
                  <span className={`${styles.word6}`}>{myStudyCount}门考试</span>
                </div>
                <div className={`${styles.ImageText4} flex-col`}>
                  <div className={`${styles.main2} flex-col justify-between`}>
                    <div className={`${styles.bd2} flex-col`} />
                    <div className={`${styles.TextGroup4} flex-col`} onClick={goToExam}>
                      <span className={`${styles.info3}`}>去考试〉〉</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.block3} flex-col`}>
            <div className={`${styles.group3} flex-col`}>
              <div className={`${styles.ImageText5} flex-col`}>
                <div className={`${styles.mod2} flex-row justify-between`}>
                  <div className={`${styles.TextGroup5} flex-col`}>
                    <span className={`${styles.word7}`}>历史学习记录</span>
                  </div>
                  <div className={`${styles.layer4} flex-col`} />
                </div>
              </div>
              {historyStudyJsx}
            </div>
          </div>
        </div>
      </div>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(!visible)
        }}
        bodyStyle={{ height: '80vh', overflowY: 'auto' }}
      >
        {allDeptJsx}
      </Popup>
    </div> : <Loading/>
}
